import { render, staticRenderFns } from "./SegmentFilterReadonly.vue?vue&type=template&id=3089c6f6&"
import script from "./SegmentFilterReadonly.vue?vue&type=script&lang=js&"
export * from "./SegmentFilterReadonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports